"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  Client: true,
  Context: true,
  Reporter: true,
  Shell: true
};
var _client = _interopRequireDefault(require("./model/client"));
exports.Client = _client["default"];
var _context = _interopRequireDefault(require("./model/context"));
exports.Context = _context["default"];
var _reporter = _interopRequireDefault(require("./model/reporter"));
exports.Reporter = _reporter["default"];
var _shell = _interopRequireDefault(require("./model/shell"));
exports.Shell = _shell["default"];
var _client2 = require("./types/client");
Object.keys(_client2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _client2[key]) return;
  exports[key] = _client2[key];
});
var _collector = require("./types/collector");
Object.keys(_collector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _collector[key]) return;
  exports[key] = _collector[key];
});
var _processor = require("./types/processor");
Object.keys(_processor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _processor[key]) return;
  exports[key] = _processor[key];
});
var _reporter2 = require("./types/reporter");
Object.keys(_reporter2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _reporter2[key]) return;
  exports[key] = _reporter2[key];
});
var _rumEvent = require("./types/rum-event");
Object.keys(_rumEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _rumEvent[key]) return;
  exports[key] = _rumEvent[key];
});
var _shell2 = require("./types/shell");
Object.keys(_shell2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shell2[key]) return;
  exports[key] = _shell2[key];
});
var _base = require("./utils/base");
Object.keys(_base).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _base[key]) return;
  exports[key] = _base[key];
});
var _polyfills = require("./utils/polyfills");
Object.keys(_polyfills).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _polyfills[key]) return;
  exports[key] = _polyfills[key];
});
var _is = require("./utils/is");
Object.keys(_is).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _is[key]) return;
  exports[key] = _is[key];
});
var _number = require("./utils/number");
Object.keys(_number).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _number[key]) return;
  exports[key] = _number[key];
});
var _match = require("./utils/match");
Object.keys(_match).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _match[key]) return;
  exports[key] = _match[key];
});
var _trace = require("./utils/trace");
Object.keys(_trace).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _trace[key]) return;
  exports[key] = _trace[key];
});
var _verify = require("./utils/verify");
Object.keys(_verify).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _verify[key]) return;
  exports[key] = _verify[key];
});